module.exports = __webpack_public_path__ + "img/datosfacturacion.540760a9.png";